<template>
  <b-form-group
    label="Iban No"
    label-for="iban"
  >
    <b-form-input
      id="iban"
      v-model="dataItem.iban"
      placeholder="Iban No"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'Iban',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
  },
}
</script>
